import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

const UserProfile = props => {
  const user = props.profile;
  const firebaseInfo = props.auth;
  const firstName = user ? user.firstName : "";
  const lastName = user ? user.lastName : "";
  const emailAddress = firebaseInfo ? firebaseInfo.email : "";

  return (
    <React.Fragment>
      <div className="container">
        <div className="row">
        <h3>My profile</h3>
        </div>
        <div className="row">

        <p>First Name: {firstName}</p>
        <p>Last Name: {lastName}</p>
        <p>Email address: {emailAddress}</p>
      </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "users" }])
)(UserProfile);
